/*
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2022-01-11 17:31:21
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-07-25 10:49:03
 * @FilePath: \合联\oms\src\api\system\department.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from "@/libs/api.request";
// 获取列表
export const getDepartment = params => {
  return axios.request({
    url: "/common/department",
    params: {
      isTree: 1
    },
    method: "get"
  });
};
// 创建列表
export const add = data => {
  return axios.request({
    url: "/common/department",
    data,
    method: "post"
  });
};
// 获取详情
export const getDetails = id => {
  return axios.request({
    url: `/common/department/${id}`,
    method: "GET"
  });
};
// 更新列表
export const update = data => {
  return axios.request({
    url: `/common/department/${data.id}`,
    method: "put",
    data
  });
};

// 删除列表
export const del = id => {
  return axios.request({
    url: `/common/department/${id}`,
    method: "DELETE"
  });
};

export const sales = id => {
  return axios.request({
    url: `/common/team/sales`,
    method: "GET"
  });
};

export const salesSave = data => {
  return axios.request({
    url: "/common/team/sales",
    data,
    method: "post"
  });
};

export const delSales = id => {
  return axios.request({
    url: `/common/team/sales/${id}`,
    method: "DELETE"
  });
};